import { EscHotKeyIcon } from '@modules/common/components/HotKeyIcons';
import { useMuiModalContext } from '@modules/common/components/Modal/ModalContext';
import ModalHeader from '@modules/common/components/Modal/ModalHeader';
import { useDisableIntegration } from '@modules/integrationsV2/hooks';
import { LoadingButton } from '@mui/lab';
import {
  Button,
  DialogActions,
  DialogContent,
  Stack,
  Typography,
} from '@mui/material';
import { IntegrationChannelType } from 'generated/graphql';
import { UUID } from 'v2/core/entities/uuid';

interface DisconnectSlackConfirmationModalProps {
  integrationID: UUID;
  onCompleted: () => void;
}

export const DisconnectSlackConfirmationModal = ({
  integrationID,
  onCompleted,
}: DisconnectSlackConfirmationModalProps) => {
  const { closeModal } = useMuiModalContext();

  const {
    disableIntegration: disconnectSlack,
    isLoading: isDisconnectingSlack,
  } = useDisableIntegration({
    channelType: IntegrationChannelType.Slack,
    onCompleted: () => {
      closeModal();
      onCompleted();
    },
    successMessage: 'Disconnected Slack successfully.',
  });

  return (
    <>
      <ModalHeader title="Disconnect Slack?" showCloseButton={false} />
      <DialogContent dividers>
        <Typography variant="body1">
          Disconnecting your Slack will remove subscribed Slack channels from
          all your reports. These wouldn't automatically resume by re-connecting
          Slack.
        </Typography>
        <Typography variant="body1" sx={{ mt: 2 }}>
          Are you sure you want to disconnect Slack?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Stack direction="row" m={2} spacing={2}>
          <Button
            variant="outlined"
            onClick={() => closeModal()}
            endIcon={<EscHotKeyIcon />}
          >
            No, Keep It
          </Button>
          <LoadingButton
            variant="contained"
            autoFocus
            onClick={() => disconnectSlack(integrationID)}
            loading={isDisconnectingSlack}
            color="error"
          >
            Yes, Disconnect
          </LoadingButton>
        </Stack>
      </DialogActions>
    </>
  );
};
